var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BarChart',{attrs:{"chartData":_vm.chartDataCity}})
}
var staticRenderFns = []

export { render, staticRenderFns }